"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGlobalAid = exports.setGlobalAid = exports.setGlobalAidRaw = exports.POSITIONS = void 0;
var txdocs_aid_1 = require("@tencent/txdocs-aid");
var txdocs_aid_2 = require("@tencent/txdocs-aid");
Object.defineProperty(exports, "POSITIONS", { enumerable: true, get: function () { return txdocs_aid_2.POSITIONS; } });
var setGlobalAidRaw = function (aid) {
    try {
        localStorage.setItem('aid', aid);
    }
    catch (error) {
        console.error('error when setting aid', error);
        window.__aid__ = aid;
    }
};
exports.setGlobalAidRaw = setGlobalAidRaw;
var setGlobalAid = function (props) {
    var position = props.position, feature = props.feature, apprec1 = props.apprec1, apprec2 = props.apprec2, apprec3 = props.apprec3;
    var aid = (0, txdocs_aid_1.getAidForReport)({
        position: position,
        feature: feature,
        apprec1: apprec1,
        apprec2: apprec2,
        apprec3: apprec3
    });
    (0, exports.setGlobalAidRaw)(aid);
};
exports.setGlobalAid = setGlobalAid;
var getGlobalAid = function () {
    try {
        var aid = localStorage.getItem('aid');
        localStorage.removeItem('aid');
        return aid;
    }
    catch (error) {
        console.error(error);
        var aid = window.__aid__;
        delete window.__aid__;
        return aid;
    }
};
exports.getGlobalAid = getGlobalAid;
//# sourceMappingURL=index.js.map